import { connect } from 'react-redux'
import { compose } from 'redux'
import { createStructuredSelector } from 'reselect'
import { withStyles } from '@material-ui/core'

import { BigCalendarBodyBase } from './BigCalendarBody'

import { sourcesSelector, monthSourcesDataSelector } from 'reduxModules/selectors/SourceSelectors'
import { sourceActions } from 'reduxModules/actions/SourceActions'
import { dateSelector } from 'reduxModules/selectors/DateSelectors'

import { styles } from './styles'

const mapStateToProps = createStructuredSelector({
  date: dateSelector,
  sources: sourcesSelector,
  monthSourcesData: monthSourcesDataSelector,
})

const mapDispatchToProps = {
  setMonthSourcesData: sourceActions.setMonthSourcesData,
  updateMonthSourcesData: sourceActions.updateMonthSourcesData,
  subscribeMonthSourcesData: sourceActions.subscribeMonthSourcesData
}

const enhance = compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)
)

export const BigCalendarBody = enhance(BigCalendarBodyBase)



// WEBPACK FOOTER //
// ./src/components/BigCalendar/components/BigCalendarBody/index.js